module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "main_content"
  }, [_c('header', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "top_header"
  }, [_c('ul', {
    staticClass: "list-unstyled list-inline pull-right"
  }, [(_vm.userID !== '') ? _c('li', {
    staticClass: "hidden-xs"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_vm._v("登出")])]) : _vm._e(), _vm._v(" "), (_vm.userID !== '') ? _c('li', {
    staticClass: "hidden-xs"
  }, [_c('a', {
    attrs: {
      "href": "/member/consume"
    }
  }, [_vm._v("會員中心")])]) : _vm._e(), _vm._v(" "), (_vm.userID !== '') ? _c('li', [_vm._v("歡迎 " + _vm._s(this.userName))]) : _vm._e(), _vm._v(" "), (_vm.userID === '') ? _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-user",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#",
      "data-toggle": "modal",
      "data-target": ".login_modal"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t登入 / 註冊")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "btn btn-default i80_btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showCartList()
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t購物車("), (_vm.items) ? _c('span', [_vm._v(_vm._s(_vm.items.length))]) : _vm._e(), _vm._v(")\n\t\t\t\t\t\t\t")])])]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCart),
      expression: "showCart"
    }],
    staticClass: "cart"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.items !== ''),
      expression: "items !==''"
    }],
    staticClass: "cart_list"
  }, [_c('ul', {
    staticClass: "list-unstyled"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('li', {
      staticClass: "item",
      attrs: {
        "transition": "fade"
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-5 col-xs-5"
    }, [_c('figure', {
      staticClass: "pic"
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": 'https://files.i80.com.tw/images/product/' + item.imageL
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-7  col-xs-7"
    }, [_c('span', [_vm._v(_vm._s(item.price) + "x" + _vm._s(item.quantity))]), _vm._v(" "), _c('span', {
      staticClass: "glyphicon glyphicon-trash pull-right delete",
      on: {
        "click": function($event) {
          _vm.DELETE_TO_CART(item)
        }
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.name))])])])])
  }))]), _vm._v(" "), _c('router-link', {
    staticClass: "checkout pull-right",
    attrs: {
      "to": '/cart'
    }
  }, [_c('button', {
    staticClass: "btn btn-default i80_btn",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("結帳去"), _c('span', {
    staticClass: "glyphicon glyphicon-arrow-right"
  })])])], 1)])])]), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-default navbar-static-top"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(1, false, false), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse main_menu",
    attrs: {
      "id": "bs-example-navbar-collapse-1"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [(_vm.userID !== '') ? _c('li', {
    staticClass: "visible-xs"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_vm._v("登出")])]) : _vm._e(), _vm._v(" "), (_vm.userID !== '') ? _c('li', {
    staticClass: "visible-xs"
  }, [_c('a', {
    attrs: {
      "href": "/member"
    }
  }, [_vm._v("會員中心")])]) : _vm._e(), _vm._v(" "), _vm._m(2, false, false), _vm._v(" "), _vm._m(3, false, false), _vm._v(" "), _vm._m(4, false, false), _vm._v(" "), _vm._m(5, false, false), _vm._v(" "), _vm._m(6, false, false), _vm._v(" "), _vm._m(7, false, false), _vm._v(" "), _vm._m(8, false, false), _vm._v(" "), _c('hr')])])])]), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), _vm._m(9, false, false), _vm._v(" "), _c('div', {
    staticClass: "modal fade login_modal",
    attrs: {
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "gridSystemModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog  modal-sm",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(10, false, false), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "login_account"
    }
  }, [_vm._v("帳號(Email)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "login_account",
      "placeholder": "帳號(Email)"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v("\n\t\t\t\t\t\t(忘記Email可至忘記密碼進行查詢)\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "login_pwd"
    }
  }, [_vm._v("密碼")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "login_pwd",
      "placeholder": "密碼"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-success btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.login()
      }
    }
  }, [_vm._v("登入")]), _vm._v(" "), _vm._m(11, false, false)])]), _vm._v(" "), _vm._m(12, false, false)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "list-unstyled list-inline"
  }, [_c('li', {
    staticClass: "hidden-xs"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-earphone",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "tel:034593159"
    }
  }, [_vm._v("03-4593159")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "tel:0909413131"
    }
  }, [_vm._v("0909-413-131")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("愛幫您股份有限公司 統編:23882568")])]), _vm._v(" "), _c('li', {
    staticClass: "hidden-xs"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-home",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://maps.google.com/?q=台東縣關山鎮德高里永豐10之1號",
      "target": "_blank"
    }
  }, [_vm._v("台東縣關山鎮德高里永豐10之1號")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/i80earnyourmoney/"
    }
  }, [_vm._v("Facebook")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-header"
  }, [_c('button', {
    staticClass: "navbar-toggle collapsed mobile_menu_btn",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#bs-example-navbar-collapse-1",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })]), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "id": "logo",
      "href": "/"
    }
  }, [_c('h1', [_vm._v("i80愛幫您")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/news"
    }
  }, [_vm._v("最新消息")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("關於我們"), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "/about"
    }
  }, [_vm._v("關於i80")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/about"
    }
  }, [_vm._v("我們的會員")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/privacy"
    }
  }, [_vm._v("隱私權政策")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/privacy"
    }
  }, [_vm._v("使用條款")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/search/product"
    }
  }, [_vm._v("商品查詢")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/store"
    }
  }, [_vm._v("聯盟店家")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/freetrial"
    }
  }, [_vm._v("立即體驗")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/alliance"
    }
  }, [_vm._v("聯盟中心")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/product"
    }
  }, [_vm._v("購物商城")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3 col-xs-12"
  }, [_c('div', {
    staticClass: "job_box"
  }, [_c('figure', {
    staticClass: "img"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/images/index/homebottom.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("你想幫助更多的人在網上賺錢嗎？如果你對數位行銷有興趣和熱情，歡迎你加入我們！")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4 col-xs-12"
  }, [_c('div', {
    staticClass: "about_box"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("認識愛幫您")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("愛幫您是台灣專業聯盟行銷平台。我們提供推廣者至少10%以上的回饋，成效可即時查詢，\n\t\t\t\t\t\t\t\t具有自行代理的優質商品外，結合聯盟店家提供客制化服務，我們提供廠商使用成效收費模式，依據消費者實際購物來計算回饋金，\n\t\t\t\t\t\t\t\t有效降低您的行銷風險，提升報酬率。")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("關於我們")]), _vm._v(" "), _c('ul', {
    staticClass: "submenu list-unstyled"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "/about"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-minus"
  }), _vm._v("關於我們")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/ourteam"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-minus"
  }), _vm._v("我們的會員")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/privacy"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-minus"
  }), _vm._v("隱私權政策")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/term"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-minus"
  }), _vm._v("使用條款")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/operators"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-minus"
  }), _vm._v("聯盟經營者")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/product"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-minus"
  }), _vm._v("購物商城")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("相關資訊")]), _vm._v(" "), _c('ul', {
    staticClass: "submenu list-unstyled"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "/contact"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-minus"
  }), _vm._v("聯絡我們")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/faq"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-minus"
  }), _vm._v("FAQ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/store"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-minus"
  }), _vm._v("聯盟商家")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/product"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-minus"
  }), _vm._v("產品列表")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("加入Line@")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/images/index/i80line.png"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {}, [_c('ul', {
    staticClass: "list-unstyled visible-xs"
  }, [_c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-earphone",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "tel:034593159"
    }
  }, [_vm._v("(03)4593-159")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "tel:0909413131"
    }
  }, [_vm._v("0909-413-131")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-envelope",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("drwateri80@gmail.com")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "glyphicon glyphicon-home",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("台東縣關山鎮德高里永豐10之1號")]), _vm._v(" "), _c('li', [_vm._v("Copyright © 2016 愛幫您股份有限公司版權所有 法律顧問「宸穎律師事務所」")])]), _vm._v(" "), _c('p', {
    staticClass: "hidden-xs"
  }, [_vm._v("Copyright © 2016 愛幫您股份有限公司版權所有 營業人：賴發雲 統一編號：23882568")]), _vm._v(" "), _c('p', {
    staticClass: "hidden-xs"
  }, [_vm._v("法律顧問「宸穎律師事務所」")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "gridSystemModalLabel"
    }
  }, [_vm._v("註冊 / 登入")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "href": "/forgotpass"
    }
  }, [_c('small', [_vm._v("忘記密碼")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-left modal-footer"
  }, [_c('a', {
    staticClass: "btn btn-info btn-sm",
    attrs: {
      "href": "/register"
    }
  }, [_vm._v("一般註冊")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-886673de"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue
// module id = 313
// module chunks = 1